import { render, staticRenderFns } from "./AffSubWhiteList.vue?vue&type=template&id=c8e90f58&scoped=true"
import script from "./AffSubWhiteList.vue?vue&type=script&lang=js"
export * from "./AffSubWhiteList.vue?vue&type=script&lang=js"
import style0 from "./AffSubWhiteList.vue?vue&type=style&index=0&id=c8e90f58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e90f58",
  null
  
)

export default component.exports